var IconItem = /** @class */ (function () {
    function IconItem(size, icon, iconSize, radius, color) {
        this.size = size;
        this.icon = icon;
        this.iconSize = iconSize;
        this.radius = radius;
        this.color = color;
    }
    return IconItem;
}());
export { IconItem };
var AppSideBarItem = /** @class */ (function () {
    function AppSideBarItem(translateKey, translateKeyOptional, isExternal, link, specialElement, tooltipKey, icon, cssClass, action, notification) {
        if (isExternal === void 0) { isExternal = false; }
        if (link === void 0) { link = ''; }
        if (specialElement === void 0) { specialElement = null; }
        if (tooltipKey === void 0) { tooltipKey = null; }
        this.tooltipKey = tooltipKey;
        this.link = link;
        this.isExternal = isExternal;
        this.translateKey = translateKey;
        this.translateKeyOptional = translateKeyOptional;
        this.cssClass = cssClass;
        this.specialElement = specialElement;
        this.action = action;
        this.icon = icon;
        this.notification = notification;
    }
    return AppSideBarItem;
}());
export { AppSideBarItem };
//# sourceMappingURL=app-sidebar-item.js.map